"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrazeProvider = exports.BrazeContext = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _pwaKit = require("../pwa-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BrazeContext = exports.BrazeContext = /*#__PURE__*/(0, _react.createContext)({
  initialize: () => {},
  loginCustomer: () => {},
  setSubscriptionState: () => {},
  sendLastViewedProductEvent: () => {}
});
/**
 * Braze Provider
 * May use Braze SDK or SCAPI call, depending on the use case
 *
 * @param sdkKey string
 * @param brazeUrl string
 * @param children React.ReactNode
 */
const BrazeProvider = ({
  children,
  sdkKey,
  brazeUrl
}) => {
  const invalidConfig = !sdkKey || !brazeUrl;
  const api = (0, _pwaKit.useCommerceAPI)();

  /**
   * Initialize Braze SDK
   *
   * @param enableLogging string
   */
  const initialize = enableLogging => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require( /* webpackExports: ['initialize', 'openSession'] */
      '@braze/web-sdk'))).then(({
        initialize,
        openSession
      }) => {
        initialize(sdkKey, {
          baseUrl: brazeUrl,
          enableLogging: enableLogging,
          doNotLoadFontAwesome: true
        });
        openSession();
      });
    } catch (error) {}
  };

  /**
   * Login the customer to Braze
   * If customer is already logged in, it does nothing
   *
   * @param userId string
   */
  const loginCustomer = userId => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require( /* webpackExports: ['changeUser'] */
      '@braze/web-sdk'))).then(({
        changeUser
      }) => {
        changeUser(userId);
      });
    } catch (error) {}
  };

  /**
   * Create 'last_viewed_product' event in Braze
   *
   * @param productId Product ID
   * @returns void
   */
  const sendLastViewedProductEvent = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* (productId) {
      if (invalidConfig) return;
      try {
        Promise.resolve().then(() => _interopRequireWildcard(require( /* webpackExports: ['logCustomEvent'] */
        '@braze/web-sdk'))).then(({
          logCustomEvent
        }) => {
          logCustomEvent('last_viewed_product', {
            product_id: productId
          });
        });
      } catch (error) {}
    });
    return function sendLastViewedProductEvent(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Set subscription state for a customer
   * Uses the SCAPI custom API instead of Braze SDK
   *
   * @param email string
   * @param subscriptionState string
   */
  const setSubscriptionState = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(function* (email, subscriptionState) {
      const params = {
        parameters: {},
        headers: {}
      };
      const body = {
        c_email: email,
        c_subscription_state: subscriptionState
      };
      try {
        const result = yield api.brazeApi.subscriptionState(params, body);

        // wrong email address does not throw error for security reasons
        if (!result.isError || (result === null || result === void 0 ? void 0 : result.title) === 'CustomerNotFoundError') {
          return {
            success: true
          };
        }
      } catch (e) {
        //
      }
      return {
        success: false
      };
    });
    return function setSubscriptionState(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(BrazeContext.Provider, {
    value: {
      initialize,
      loginCustomer,
      setSubscriptionState,
      sendLastViewedProductEvent
    }
  }, children);
};
exports.BrazeProvider = BrazeProvider;